import { PayloadAction } from "@reduxjs/toolkit";

import { State } from "../types/state";

const setAutosCoordinates = (state: State, action: PayloadAction<State['autosCoordinates']['data']>) => {
  state.autosCoordinates.data = action.payload;
};

export default setAutosCoordinates;
